import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../services/api';
import './Admin.css';

const SEOManagement: React.FC = () => {
  const [seoList, setSeoList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSEO();
  }, []);

  const loadSEO = async () => {
    try {
      const response = await adminAPI.getSEO();
      setSeoList(Array.isArray(response) ? response : (response as any).results || []);
    } catch (error) {
      console.error('Failed to load SEO data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-page">
        <div className="page-header">
          <h1>SEO Management</h1>
        </div>
        <div className="loading-state">Loading...</div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="page-header">
        <h1>SEO Management</h1>
      </div>

      <div className="seo-list">
        {seoList.length === 0 ? (
          <p>No SEO metadata configured yet.</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Page Type</th>
                <th>Meta Title</th>
                <th>Meta Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {seoList.map((item: any) => (
                <tr key={item.id}>
                  <td>{item.page_type}</td>
                  <td>{item.meta_title}</td>
                  <td>{item.meta_description}</td>
                  <td>
                    <button className="edit-btn">Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default SEOManagement;
